export const ActionType = {
  GET_INTERVIEW_REQUESTED_DEVELOPERS_STARTED:
    'GET_INTERVIEW_REQUESTED_DEVELOPERS_STARTED',
  GET_INTERVIEW_REQUESTED_DEVELOPERS: 'GET_INTERVIEW_REQUESTED_DEVELOPERS',
  GET_INTERVIEW_REQUESTED_DEVELOPERS_FINISHED:
    'GET_INTERVIEW_REQUESTED_DEVELOPERS_FINISHED',
};
